import { useEffect, useState } from 'react';
import Modal from '../../../components/organisms/modal/Modal';
import CreateNoteModalEventManager, { CreateNoteModalCustomEventType, CreateNoteModalEventData } from '../..//organisms/modal/CreateNoteModalEventManager';
import { TextArea } from '../../atoms/text-area';
import styles from './CreateNoteModal.module.css';
import Text from '../../atoms/typography/Text';
import { useTranslation } from 'react-i18next';
import { ColorEnum as ColorEnumNew, FontSizeEnum, FontWeightEnum } from '../../enums';
import ColorEnum from '../../../enums/colorEnum';
import ButtonNew from '../../molecules/button/Button';
import AddLineIcon from '../../atoms/icons/AddLineIcon';
import submitHomeseekerApplicationNote from '../../../api/homeseeker/submitHomeseekerApplicationNote';
import Notifications from '../notifications/Notifications';

interface CreateNoteModalProps {
    readonly open: boolean;
}

type CreateNoteModalComponent = (props: CreateNoteModalProps) => JSX.Element;

const createNoteModal = CreateNoteModalEventManager.create<CreateNoteModalEventData>('create-note-modal');

export const CreateNoteModalNew = ({
    open = false,
}: CreateNoteModalProps) => {
    const {t} = useTranslation();
    
    const [isOpen, setIsOpen] = useState(open);
    const [note, setNote] = useState('');
    const [homeseekerApplicationId, setHomeseekerApplicationId] = useState(null);


    const setModal = (e: CreateNoteModalCustomEventType) => {
        setIsOpen(e.detail.open);
        setHomeseekerApplicationId(e.detail.homeseekerApplicationId);
    }

    useEffect(() => {
        createNoteModal?.addListener(setModal);

        return () => {
            createNoteModal?.removeListener(setModal);
        };
    }, []);

    const handleSubmit = async () => {
        try {
            await submitHomeseekerApplicationNote({
                note: note,
                homeseekerApplicationId: homeseekerApplicationId
            });

            Notifications.add({
                message: t('candidate.notes.createNote.success.title'),
                type: 'success'
            });
        } catch (e) {
            Notifications.add({
                message: t('candidate.notes.createNote.error.title'),
                type: 'failed'
            });
        } finally {
            createNoteModal.close();
        }
    }

    return (
        <Modal
            icon={'ri-pencil-line'}
            iconColor={ColorEnum.Primary600}
            iconBackgroundColor={ColorEnum.Primary100}
            flowyColor={ColorEnum.Primary100}
            manager={createNoteModal}
            isOpen={isOpen}
        >
            <div className={styles.note}>
                <Text
                    weight={FontWeightEnum.Semibold}
                    size={FontSizeEnum.Lg}
                    color={ColorEnumNew.Primary700}
                >
                    {t('candidate.create.note.title')}
                </Text>
                <TextArea
                    id="note"
                    onChange={(n, value) => { setNote(value) }}
                />
                <ButtonNew
                    className={styles.noteButton}
                    iconBefore={<AddLineIcon/>}
                    type='submit'
                    onClick={handleSubmit}
                >
                    {t('candidate.create.note.button')}
                </ButtonNew>
            </div>
        </Modal>
    );
}

Object.assign(CreateNoteModalNew, createNoteModal);

export default (CreateNoteModalNew as CreateNoteModalComponent & CreateNoteModalEventManager<CreateNoteModalEventData>);
